import React from 'react'
import './HorizontalDivider.css'

export default function HorizontalDivider({ style, secondary }) {
    if (secondary) {
        return (
            <div style={style} className="horizontal-divider-secondary"></div>
        )
    }
    else {
        return (
            <div style={style} className="horizontal-divider"></div>
        )
    }

}
